import { Link } from "react-router-dom";
import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/courses-banner/course-opera-banner.jpg" alt="Guitar Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>O</span>
                                    <span>P</span>
                                    <span>E</span>
                                    <span>R</span>
                                    <span>A</span>
                                    <span>&nbsp;</span>
                                    <span>S</span>
                                    <span>I</span>
                                    <span>N</span>
                                    <span>G</span>
                                    <span>I</span>
                                    <span>N</span>
                                    <span>G</span>
                                </div>
                            </h1>
                            <div className="hero-cta">
                                <Link to="/admission-form" className="cta-button">ENROLL NOW</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 